import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppServiceHelperService } from '../../../services/app-service-helper.service';

/**
 * Injectable
 */
@Injectable({
  providedIn: 'root'
})
export class PublishService {
  /**
   * Constructor
   */
  constructor(private appServiceHelper: AppServiceHelperService, private httpClient: HttpClient) { }

  /**
   * Gets valuation portfolio publish info
   * @param valuationProjectId Oid
   * */
  getValuationPortfolioPublishInfo(valuationProjectId: any): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/valuationPortfolioPublishInfo?valuationProjectId=${valuationProjectId}`)).pipe(take(1));
  }

  /**
   * Print publish for reports
   * @param request Request
   * */
  printPublishPortfolio(request: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `printpublish/portfolio`), request).pipe(
      map((data) => {
        if (data.success) {
          return data;
        }
      })
    );
  }

  /**
   * Print publish for reports
   * @param request Request
   * */
  printPublishReport(request: any) {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `printpublish/report`), request).pipe(
      map((data) => {
        if (data.success) {
          return data;
        }
      })
    );
  }

  /**
   * Gets reports for the VE OID
   * @param valuationProjectId
   * @returns
   */
  reportFilter(valuationProjectId: any) {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.projectValuation.api', `Reports/filter?valuationProjectId=${valuationProjectId}`)).pipe(take(1));
  }
}
